import { Component, OnInit } from "@angular/core";
import { NgxSpinnerModule, NgxSpinnerService } from "ngx-spinner";
import { ToastrService } from "ngx-toastr";
import { AppService } from "src/app/app.service";
import { BaseService } from "src/app/base/base.service";
import { environment } from "src/environments/environment";
import * as CryptoJS from "crypto-js";
import { Router } from "@angular/router";

@Component({
  selector: "app-watch-profile",
  templateUrl: "./watch-profile.component.html",
  styleUrls: ["./watch-profile.component.css"],
})
export class WatchProfileComponent implements OnInit {
  profile: any;
  peopleData: any = [];
  userInfo: any;
  constructor(
    public route: Router,
    private service: AppService,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService,
    public baseService: BaseService
  ) {}

  ngOnInit(): void {
    const encryptedData = localStorage.getItem(environment.localStorageKey);
    if (encryptedData) {
      this.getpeopleList();
      this.userInfo = JSON.parse(
        CryptoJS.AES.decrypt(encryptedData, environment.secretkey).toString(
          CryptoJS.enc.Utf8
        )
      );
    } else {
      this.route.navigate(["/"]);
    }
  }

  changeProfile(data: any) {
    this.baseService.profile = data;
    this.userInfo.profile_id = data.id;
    const encryptData = CryptoJS.AES.encrypt(
      JSON.stringify(this.userInfo),
      environment.secretkey
    ).toString();
    localStorage.setItem(environment.localStorageKey, encryptData);
    this.route.navigate(["/home"]);
  }
  getpeopleList() {
    this.spinner.show();
    this.service.getPeopleList().subscribe(
      (res: any) => {
        this.peopleData = res.results;
        this.peopleData.map((el) => {
          el.color = el.color ? el.color : "yellow";
        });
        this.spinner.hide();
      },
      (err) => {
        this.spinner.hide();
        this.toastr.error(err.error.message, "OOPS!", {
          closeButton: true,
        });
      }
    );
  }
}
